import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { getApiErrorMessage } from "../getApiErrorMessage";

export interface UpdateEventVenueRequest {
  name?: string;
  address?: string;
  locationId?: number;
  type?: "RESTAURANT" | "AFTER_PARTY";
}

export interface EventVenueResponse {
  id: number;
  name: string;
  address: string;
  locationId?: number | null;
  locationName?: string | null;
  type: "RESTAURANT" | "AFTER_PARTY";
}

export const useUpdateEventVenue = () => {
  const queryClient = useQueryClient();

  return useMutation<EventVenueResponse, Error, { id: number; data: UpdateEventVenueRequest }>({
    mutationFn: async ({ id, data }) => {
      const response = await apiFetch(`api/event/venues/${id}`, {
        method: "PATCH",
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["event-venues"] }),
  });
};
